import login from '@/views/login' //登录
// import layout from '@/views/layout/Layout' //框架
import stores from '@/views/stores' //门店列表
import coachesList from '@/views/coachesList' //教练列表
import courses from '@/views/courses' //课程类型
import coursesList from '@/views/coursesList' //课程列表
import directorCourseList from '@/views/coursesList/directorCourseList' //课程列表

import courseConfiguration from '@/views/coursesList/courseConfiguration' //课程配置
import trainingPlan from '@/views/coursesList/trainingPlan' //训练计划
import addTrainingPlan from '@/views/coursesList/trainingPlan/addTrainingPlan' //创建训练计划
import collection from '@/views/coursesList/collection/list' //精选合集
import addcollection from '@/views/coursesList/collection/addcollection' //创建精选合集

import courseFreeConfiguration from '@/views/coursesList/courseFreeConfiguration' //课程限免配置
import specifiedCourseList from '@/views/coursesList/specifiedCourseList' //指定用户课程列表


import liveBroadcast from '@/views/liveBroadcast' //直播列表
import indexBg from '@/views/indexBg' //首页背景
import usersList from '@/views/usersList' //用户列表
import userPoints from '@/views/usersList/userPoints' //充值亿米
import videoList from '@/views/videoList' //视频列表
import videoLists from '@/views/videoList/videoLists' //运营视频列表
import videoReportList from '@/views/videoList/videoReportList' //视频举报列表
import videoConfiguration from '@/views/videoList/videoConfiguration' //视频内容热度维度配置
import payList from '@/views/payList' //付费列表
import courseBinding from '@/views/payList/courseBinding' //课程付费绑定
import forgotPassword from '@/views/forgotPassword' //修改密码
import questionnaireList from '@/views/questionnaireList' //问卷
import conversionCodeList from '@/views/conversionCodeList' //兑换码列表
import commodityManagement from '@/views/commodityManagement' //商品管理
import mallEntrance from '@/views/commodityManagement/mallEntrance' //商品管理-商城入口

import menuList from '@/views/authorityManagement/menuList' //权限管理-菜单列表
import roleList from '@/views/authorityManagement/roleList' //权限管理-角色列表
import personnelList from '@/views/authorityManagement/personnelList' //权限管理-人员列表

import appList from '@/views/versionManagement/appList' //版本管理-APP列表

import report from '@/views/report' //报表
import homekcal from '@/views/report/homekcal' //小乔动感单车用户卡路里燃脂榜
import homekcalDetail from '@/views/report/homekcalDetail' //小乔动感单车用户卡路里燃脂榜详情

import competitionManagement from '@/views/competitionManagement' //竞赛管理
import actionLibraryList from '@/views/actionLibraryList' //动作库管理

import memberManagement from '@/views/memberManagement' //会员管理
import aiMembers from '@/views/memberManagement/aiMembers' //Ai会员列表
import qaSection from '@/views/qaSection' //问答专区

import stageName from '@/views/stageName' //小乔花名
import trainCampCouseApply from '@/views/trainingCamp/trainCampCouseApply' //训练营课程报名列表
import campClock from '@/views/trainingCamp/campClock' //训练营打卡
import campApply from '@/views/trainingCamp/campApply' //训练营报名

import smartModeList from '@/views/smartModeList/index' // 智能模式跑
import hrModeList from '@/views/smartModeList/hrModeList' // 智能模式跑
import course_live_background from '@/views/backgroundImg/course_live_background' // 直播课背景图  
import course_live_coer from '@/views/backgroundImg/course_live_coer' // 直播课封面图
import course_video_cover from '@/views/backgroundImg/course_video_cover' // 点播课封面图   
import course_intro_video from '@/views/backgroundImg/course_intro_video' // 课程介绍页视频  
import course_intro_cover from '@/views/backgroundImg/course_intro_cover' // 课程介绍页封面  

import Index from '@/index' //共用模块

export default [{
    path: '/',
    name: '/',
    redirect: {
      name: 'login'
    }
  },
  {
    path: '/login',
    name: 'login',
    component: login
  },
  {
    path: '/index',
    name: 'Index',
    component: Index,
    children: [
      // {
      //   path: '/stores',
      //   component: stores,
      //   name: 'stores',
      //   meta: {
      //     title: '门店列表',
      //     noCache: true,
      //     requireAuth: true
      //   }
      // },
      {
        path: '/coacheslist',
        component: coachesList,
        name: 'coachesList',
        meta: {
          title: 'coacheslist',
          noCache: true
        }
      },
      {
        path: '/courses',
        component: courses,
        name: 'courses',
        meta: {
          title: '课程类型',
          noCache: true
        }
      },
      {
        path: '/courseslist',
        component: coursesList,
        name: 'coursesList',
        meta: {
          title: '课程列表',
          noCache: true
        }
      },
      {
        path: '/directorCourseList',
        component: directorCourseList,
        name: 'directorCourseList',
        meta: {
          title: '导演课程列表',
          noCache: true
        }
      },
      {
        path: '/trainingPlan',
        component: trainingPlan,
        name: 'trainingPlan',
        meta: {
          title: '训练计划',
          noCache: true
        }
      },
      {
        path: '/addTrainingPlan',
        component: addTrainingPlan,
        name: 'addTrainingPlan',
        meta: {
          title: '创建训练计划',
          noCache: true
        }
      },
      {
        path: '/collection',
        component: collection,
        name: 'collection',
        meta: {
          title: '精选合集',
          noCache: true
        }
      },
      {
        path: '/addcollection',
        component: addcollection,
        name: 'addcollection',
        meta: {
          title: '新增精选合集',
          noCache: true
        }
      },
      {
        path: '/courseFreeConfiguration',
        component: courseFreeConfiguration,
        name: 'courseFreeConfiguration',
        meta: {
          title: '课程限免配置',
          noCache: true
        }
      },
      {
        path: '/specifiedCourseList',
        component: specifiedCourseList,
        name: 'specifiedCourseList',
        meta: {
          title: '指定用户课程列表',
          noCache: true
        }
      },
      {
        path: '/courseConfiguration',
        component: courseConfiguration,
        name: 'courseConfiguration',
        meta: {
          title: '课程评分配置',
          noCache: true
        }
      },
      {
        path: '/livebroadcast',
        component: liveBroadcast,
        name: 'liveBroadcast',
        meta: {
          title: '直播列表',
          noCache: true
        }
      },
      {
        path: '/indexBg',
        component: indexBg,
        name: 'indexBg',
        meta: {
          title: '首页背景',
          noCache: true
        }
      },
      {
        path: '/userslist',
        component: usersList,
        name: 'usersList',
        meta: {
          title: '用户列表',
          noCache: true
        }
      },
      {
        path: '/userPoints',
        component: userPoints,
        name: 'userPoints',
        meta: {
          title: '充值亿米',
          noCache: true
        }
      },
      // {
      //   path: '/videoReportList',
      //   component: videoReportList,
      //   name: 'videoReportList',
      //   meta: {
      //     title: '视频举报列表',
      //     noCache: true
      //   }
      // },
      // {
      //   path: '/videolist',
      //   component: videoList,
      //   name: 'videoList',
      //   meta: {
      //     title: '短视频列表',
      //     noCache: true
      //   }
      // },
      // {
      //   path: '/videolists',
      //   component: videoLists,
      //   name: 'videoLists',
      //   meta: {
      //     title: '短视频列表',
      //     noCache: true
      //   }
      // },
      // {
      //   path: '/videoConfiguration',
      //   component: videoConfiguration,
      //   name: 'videoConfiguration',
      //   meta: {
      //     title: '视频热度配置',
      //     noCache: true
      //   }
      // },
      {
        path: '/payList',
        component: payList,
        name: 'payList',
        meta: {
          title: '付费列表',
          noCache: true
        }
      },
      {
        path: '/courseBinding',
        component: courseBinding,
        name: 'courseBinding',
        meta: {
          title: '课程付费绑定',
          noCache: true
        }
      },
      {
        path: '/forgotPassword',
        component: forgotPassword,
        name: 'forgotPassword',
        meta: {
          title: '修改密码',
          noCache: true
        }
      },
      {
        path: '/questionnaireList',
        component: questionnaireList,
        name: 'questionnaireList',
        meta: {
          title: '问卷列表',
          noCache: true
        }
      },
      {
        path: '/conversionCodeList',
        component: conversionCodeList,
        name: 'conversionCodeList',
        meta: {
          title: '兑换码列表',
          noCache: true
        }
      },
      {
        path: '/commodityManagement',
        component: commodityManagement,
        name: 'commodityManagement',
        meta: {
          title: '商品管理',
          noCache: true
        }
      },
      {
        path: '/mallEntrance',
        component: mallEntrance,
        name: 'mallEntrance',
        meta: {
          title: '商城入口管理',
          noCache: true
        }
      },
      {
        path: '/menuList',
        component: menuList,
        name: 'menuList',
        meta: {
          title: '菜单列表',
          noCache: true
        }
      },
      {
        path: '/roleList',
        component: roleList,
        name: 'roleList',
        meta: {
          title: '角色列表',
          noCache: true
        }
      },
      {
        path: '/personnelList',
        component: personnelList,
        name: 'personnelList',
        meta: {
          title: '人员列表',
          noCache: true
        }
      },
      {
        path: '/appList',
        component: appList,
        name: 'appList',
        meta: {
          title: 'APP列表',
          noCache: true
        }
      },
      {
        path: '/report',
        component: report,
        name: 'report',
        meta: {
          title: '报表',
          noCache: true
        }
      },
      {
        path: '/homekcal',
        component: homekcal,
        name: 'homekcal',
        meta: {
          title: '单车燃脂榜',
          noCache: true
        }
      },
      {
        path: '/homekcalDetail',
        component: homekcalDetail,
        name: 'homekcalDetail',
        meta: {
          title: '单车燃脂榜详情',
          noCache: true
        }
      },
      {
        path: '/competitionManagement',
        component: competitionManagement,
        name: 'competitionManagement',
        meta: {
          title: '竞赛管理',
          noCache: true
        }
      },
      {
        path: '/actionLibraryList',
        component: actionLibraryList,
        name: 'actionLibraryList',
        meta: {
          title: '动作库管理',
          noCache: true
        }
      },
      {
        path: '/qaSection',
        component: qaSection,
        name: 'qaSection',
        meta: {
          title: '问答专区',
          noCache: true
        }
      },
      {
        path: '/memberManagement',
        component: memberManagement,
        name: 'memberManagement',
        meta: {
          title: '会员管理',
          noCache: true
        }
      },
      {
        path: '/aiMembers',
        component: aiMembers,
        name: 'aiMembers',
        meta: {
          title: 'AI会员列表',
          noCache: true
        }
      },
      {
        path: '/stageName',
        component: stageName,
        name: 'stageName',
        meta: {
          title: '小乔花名',
          noCache: true
        }
      },
      {
        path: '/trainCampCouseApply',
        component: trainCampCouseApply,
        name: 'trainCampCouseApply',
        meta: {
          title: '课程报名列表',
          noCache: true
        }
      },
      {
        path: '/campClock',
        component: campClock,
        name: 'campClock',
        meta: {
          title: '训练营打卡',
          noCache: true
        }
      },
      {
        path: '/campApply',
        component: campApply,
        name: 'campApply',
        meta: {
          title: '训练营报名',
          noCache: true
        }
      }, 
      {
        path: '/smartModeList',
        component: smartModeList,
        name: 'smartModeList',
        meta: {
          title: '智能模式跑',
          noCache: true
        }
      },
      {
        path: '/hrModeList',
        component: hrModeList,
        name: 'hrModeList',
        meta: {
          title: 'AI心率模式',
          noCache: true
        }
      },
      {
        path: '/course_live_background',
        component: course_live_background,
        name: 'course_live_background',
        meta: {
          title: '直播课背景图',
          noCache: true
        }
      },
      {
        path: '/course_live_coer',
        component: course_live_coer,
        name: 'course_live_coer',
        meta: {
          title: '直播课封面图',
          noCache: true
        }
      },        
      {
        path: '/course_video_cover', 
        component: course_video_cover,
        name: 'course_video_cover',
        meta: {
          title: '点播课封面图', 
          noCache: true
        }
      },
      {
        path: '/course_intro_cover', 
        component: course_intro_cover,
        name: 'course_intro_cover',
        meta: {
          title: '课程介绍页封面', 
          noCache: true
        }
      },
      {
        path: '/course_intro_video', 
        component: course_intro_video,
        name: 'course_intro_video',
        meta: {
          title: '课程介绍页视频', 
          noCache: true
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/router.js